"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EffectApplyVfxStepArgs = void 0;
const uuid_1 = require("uuid");
class EffectApplyVfxStepArgs {
    constructor(effectId, location, text, textColor) {
        this.effectId = effectId;
        this.location = location;
        this.text = text;
        this.textColor = textColor;
        this.__typeName = "EffectApply";
        this.id = (0, uuid_1.v4)();
    }
}
exports.EffectApplyVfxStepArgs = EffectApplyVfxStepArgs;
